import React, { Component } from "react";
import { map } from "lodash";
import CheckboxElement from "../UI/Checkbox";

let currentid = 4;
class UserPerformance extends Component {
  render() {
    const {
      data = {},
      handleChecks,
      allChecked,
      handleAllChecks,
      checkComponent
    } = this.props;

    checkComponent.some(data => data.value) === true
      ? checkComponent.map(function(data) {
          if (data.value === true) {
            currentid = data.id;
          }
          return currentid;
        })
      : (currentid = 4);
    return (
      <div className="col-xs-4">
        <div className="orange-cards checkbox-header">
          <div
            className="card-header"
            onChange={e =>
              handleAllChecks(e.target.value, e.target.id, e.target.checked)
            }
          >
            {currentid === 4 ? (
              <CheckboxElement
                heading
                inputChecked={allChecked}
                value="User_Performance"
                id={4}
                disable={false}
                field="User Performance"
                label="User Performance"
              />
            ) : (
              <CheckboxElement
                heading
                value="User_Performance"
                inputChecked={false}
                disable={true}
                field="User Performance"
                label="User Performance"
              />
            )}
          </div>
          <div className="card-content bottom-border">
            {map(data, elem => {
              return (
                <ul
                  key={elem.id}
                  onChange={e =>
                    handleChecks(
                      e.target.value,
                      e.target.id,
                      e.target.checked,
                      4,
                      "User_Performance"
                    )
                  }
                >
                  {currentid === 4 ? (
                    <li className="mr-25 py-5">
                      <label className="flex-center-y pointer w-600">
                        <CheckboxElement
                          field={elem.title}
                          value={elem.req_name}
                          inputChecked={allChecked}
                          id={elem.id}
                          disable={false}
                          label={elem.title}
                        />
                      </label>
                    </li>
                  ) : (
                    <li className="mr-25 py-5">
                      <label className="flex-center-y pointer w-600">
                        <CheckboxElement
                          field={elem.title}
                          value={elem.req_name}
                          inputChecked={false}
                          id={elem.id}
                          disable={true}
                          label={elem.title}
                        />
                      </label>
                    </li>
                  )}
                </ul>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
export default UserPerformance;



// WEBPACK FOOTER //
// ./src/components/Management-dashboard/UserPerformance.js